<template>
  <AppModal
    :visible="visible"
    :close-button="noRejonByUser"
    persistent
    @closeButton="clearRejon"
  >
    <template
      v-if="location && noRejonByUser === false"
      #content
    >
      <p
        v-if="location"
        class="fw-600 f-2 mb-0 text-xs-left"
      >
        {{ $t('message.correct_message_text') }}
      </p>
      <p class="text-xs-left f-16 sz_grafit--text ma-0">
        {{ $t('message.correct_area_subtitle') }}
      </p>
      <v-layout mt-3>
        <v-flex xs3>
          <p class="text-xs-left f-16 sz_grafit--text ma-0 font-weight-bold">
            {{ $t('label.area') }}:
          </p>
        </v-flex>
        <v-flex>
          <p class="text-xs-left f-16 sz_grafit--text ma-0">
            {{ locationName }}
          </p>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="!isNative && locationLeaders && locationLeaders.length > 0"
        mt-2
      >
        <v-flex xs3>
          <p class="text-xs-left f-16 sz_grafit--text ma-0 font-weight-bold">
            {{ rejonLeadersTitle }}:
          </p>
        </v-flex>
        <v-flex>
          <v-layout wrap>
            <v-flex
              v-for="(leader, index) in locationLeaders"
              :key="index"
              xs12
              class="mb-2"
            >
              <p class="text-xs-left f-16 sz_grafit--text ma-0">
                {{ leader.full_name }}
              </p>
              <p class="text-xs-left f-16 sz_grafit--text ma-0">
                {{ leader.email }}
              </p>
              <p class="text-xs-left f-16 sz_grafit--text ma-0">
                {{ leader.phone | phone }}
              </p>
              <v-divider
                v-if="index !== locationLeaders.length - 1"
                class="mt-1"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="!isNative"
        align-center
        mt-3
      >
        <v-flex
          shrink
          pa-2
          pl-0
        >
          <v-icon color="sz_red">
            warning
          </v-icon>
        </v-flex>
        <v-flex
          shrink
          pa-2
          pr-0
        >
          <p class="mb-0 f-16 sz_grafit--text">
            {{ $t('message.area_reach_out') }}
          </p>
        </v-flex>
      </v-layout>
    </template>
    <template
      v-else-if="noRejonByUser"
      #content
    >
      <v-layout
        align-center
        mt-3
      >
        <v-flex
          shrink
          pa-2
          pl-0
        >
          <v-icon color="sz_red">
            warning
          </v-icon>
        </v-flex>
        <v-flex
          shrink
          pa-2
          pr-0
        >
          <p
            v-if="location == null"
            class="mb-0 f-16 sz_grafit--text"
          >
            {{ $t('message.add_family_without_rejon_by_osm') }}
          </p>
          <p
            v-else
            class="mb-0 f-16 sz_grafit--text"
          >
            {{ $t('message.add_family_without_rejon_by_user') }}
          </p>
        </v-flex>
      </v-layout>
    </template>
    <template
      v-else
      #content
    >
      <v-layout
        align-center
        mt-3
      >
        <v-flex
          shrink
          pa-2
          pl-0
        >
          <v-icon color="sz_red">
            warning
          </v-icon>
        </v-flex>
        <v-flex
          shrink
          pa-2
          pr-0
        >
          <p class="mb-0 f-16 sz_grafit--text">
            {{ $t('message.location_message') }}
          </p>
        </v-flex>
      </v-layout>
    </template>

    <template
      v-if="location && noRejonByUser === false"
      #actions
    >
      <v-layout
        wrap
        justify-space-between
        :justify-center="$vuetify.breakpoint.xsOnly"
        align-center
      >
        <v-flex
          shrink
          order-xs2
          order-sm1
          :mt-3="$vuetify.breakpoint.xsOnly"
          :mr-3="$vuetify.breakpoint.smAndUp"
        >
          <a @click="addWithoutRejon">{{ $t('buttons.incorrect_rejon') }}</a>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            :loading="loader"
            :disabled="loader"
            color="sz_violet"
            @click="acceptRejon"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template
      v-else-if="noRejonByUser"
      #actions
    >
      <v-layout
        wrap
        justify-space-between
        :justify-center="$vuetify.breakpoint.xsOnly"
        align-center
      >
        <v-flex
          shrink
          order-xs2
          order-sm1
          :mt-3="$vuetify.breakpoint.xsOnly"
          :mr-3="$vuetify.breakpoint.smAndUp"
        >
          <a @click="clearRejon">{{ $t('buttons.cancel') }}</a>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            color="sz_violet"
            @click="confirmWithoutRejon"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template
      v-else
      #actions
    >
      <v-layout
        wrap
        justify-space-between
        :justify-center="$vuetify.breakpoint.xsOnly"
        align-center
      >
        <v-flex
          shrink
          order-xs2
          order-sm1
          :mt-3="$vuetify.breakpoint.xsOnly"
          :mr-3="$vuetify.breakpoint.smAndUp"
        >
          <a @click="addWithoutRejon">{{ $t('buttons.correct_address') }}</a>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            color="sz_violet"
            @click="clearRejon"
          >
            {{ $t('buttons.correct_location') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </AppModal>
</template>

<script>
import AppModal from '@/components/widgets/AppModal';
import filters from '@/constants/filters';
export default {
    name: 'LocationDialog',
    components: { AppModal },
    filters: {
        ...filters
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        internal: {
            type: Boolean,
            default: false
        },
        loader: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        visible: false,
        noRejonByUser: false
    }),
    computed: {
        location () {
            return this.$store.getters['familyData/getLocation'];
        },
        locationLoader () {
            return this.$store.getters['familyData/getLocationLoader'];
        },
        locationNode () {
            return this.location && this.location.node;
        },
        locationName () {
            return this.locationNode && this.locationNode.name;
        },
        isNative () {
            return this.location && this.location.native;
        },
        locationLeaders () {
            return this.$store.getters['familyData/getLocationLeaders'];
        },
        rejonLeadersTitle () {
            if (this.locationLeaders && this.locationLeaders.length > 1) {
                return this.$t('message.area_leaders');
            }
            return this.$t('message.area_leader');
        }
    },
    watch: {
        value () {
            this.visible = this.value;
        }
    },
    methods: {
        closeDialog () {
            this.noRejonByUser = false;
            this.$emit('closeDialog');
        },
        acceptRejon () {
            this.$emit('acceptRejon');
        },
        addWithoutRejon () {
            if (this.internal) {
                this.noRejonByUser = true;
            } else {
                this.$emit('addWithoutRejon');
                this.closeDialog();
            }
        },
        confirmWithoutRejon () {
            this.$emit('addWithoutRejon');
            this.closeDialog();
        },
        clearRejon () {
            this.$store.commit('familyData/setLocation', null);
            this.$store.commit('familyData/setLocationLeaders', null);
            this.closeDialog();
        }
    }
};
</script>
